module.exports = __webpack_public_path__ + "static/media/Samsung-Rewards_logo.aa6cd4d6.svg";